var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wraper"},[_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_c('div',{staticClass:"top_title big"},[_vm._v("《隐私政策》历史版本")]),_c('div',{staticClass:"list_item"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"right mark",on:{"click":_vm.goBack}},[_vm._v("当前版本")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }